import { createRoot } from "react-dom/client";
import App from "./solar-system";


createRoot(document.getElementById("solar-system-root")).render(<App />);
